import { fetcher } from "helpers/fetcher";

import {
  TDecreaseJobListingSlotReq,
  TDecreaseJobListingSlotRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const decreaseJobListingSlot = async (
  payload: TDecreaseJobListingSlotReq
) => {
  return await fetcher<TDecreaseJobListingSlotRes, TDecreaseJobListingSlotReq>(
    ENDPOINT.CORPORATION.DECREASE_JOB_LISTING_SLOT,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.DECREASE_JOB_LISTING_SLOT.version,
      },
    }
  );
};

export const mutationDecreaseJobListingSlot = async (
  payload: TDecreaseJobListingSlotReq
) => {
  return (await decreaseJobListingSlot(payload)).data;
};

mutationDecreaseJobListingSlot._key = (payload: TDecreaseJobListingSlotReq) => [
  ENDPOINT.CORPORATION.DECREASE_JOB_LISTING_SLOT.url,
  payload,
];
